export default __webpack_public_path__ + "static/media/kh.803cfd99.jpg";